import { apiAxios } from "./apiConfig";

export interface ChildPermission {
  id: string;
  name: string;
}

export interface ParentPermission {
  parentId: string;
  parentName: string;
  childPermissions: ChildPermission[];
}

export interface PermissionsResponse {
  status: boolean;
  data: ParentPermission[];
}

export const getAdminPermissions = async (): Promise<PermissionsResponse> => {
  const response =
    await apiAxios.get<PermissionsResponse>("/admin/permissions");

  return response.data;
};

export interface WeeklyEngagement {
  name: string;
  users: string; // backend returns string
}

export interface DashboardMetric {
  name: string;
  count: number | WeeklyEngagement[];
}

export interface DashboardResponse {
  status: boolean;
  data: DashboardMetric[];
}

/* -----------------------------
   Get Dashboard Data
------------------------------ */

export interface DashboardParams {
  startDate: string; // YYYY-MM-DD
  endDate: string; // YYYY-MM-DD
}

export const getAdminDashboard = async (
  params: DashboardParams,
): Promise<DashboardResponse> => {
  const response = await apiAxios.get<DashboardResponse>("/admin/dashboard", {
    params: {
      startDate: params.startDate,
      endDate: params.endDate,
    },
  });

  return response.data;
};
